import { client } from '../../apiClient';

export const forceSourceReverification = async (
  urls: string[]
): Promise<{ success: boolean; queuedCount: number; totalUrls: number }> => {
  return client(true, true)
    .post('/admin/source-verification/force-reverification', { urls })
    .then((response) => response.data);
};
